import { useContext } from 'react'

import { IAuth, AuthContext } from '@provider/Shared/AuthProvider'

export default function useAuth(): IAuth {
  const context = useContext(AuthContext)

  return context
}
